
export enum DockShipmentTypeCd {
	DOCK = 'Dock',
	PICKUP = 'Pickup',
	RESHIP = 'Reship',
	STRAND = 'Strand'}

